import {updateActiveMap, updateLastMapCount} from "../../../action/gamma.state.action";
import {initSlides} from "../../../action/maps.state.action";
import {store} from "../../../helper/store";

export const mapSlides = (selectedSlides) => {
	store.dispatch(updateActiveMap('0'));
	store.dispatch(initSlides(selectedSlides));
	store.dispatch(updateLastMapCount());
}
